module.exports = __webpack_public_path__ + "static/avatar-d99480496bb94723cd1f0f1db1d36961.jpg";